// this file is generated by generate-icons.js. Do not edit!
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SVGExternalLink = props => /*#__PURE__*/_jsxs("svg", Object.assign({
  width: "1em",
  height: "1em",
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#externalLink__clip0_12_2779)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "externalLink__a",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 32,
      children: /*#__PURE__*/_jsxs("g", {
        clipPath: "url(#externalLink__clip1_12_2779)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M14 8.286c.629 0 1.143.514 1.143 1.143 0 .628-.514 1.143-1.143 1.143H6v16h16v-8c0-.63.514-1.143 1.143-1.143.628 0 1.143.514 1.143 1.143v9.142c0 .629-.515 1.143-1.143 1.143H4.857c-.628 0-1.143-.514-1.143-1.143V9.43c0-.629.515-1.143 1.143-1.143H14z"
        }), /*#__PURE__*/_jsx("path", {
          d: "M13.166 20.55h-.012l.005-.002.007.001zM27.714 3.714c.629 0 1.143.515 1.143 1.143V14c0 .629-.514 1.143-1.143 1.143-.628 0-1.143-.514-1.143-1.143V7.612L13.965 20.218c-.227.227-.51.329-.806.33-.294-.001-.577-.115-.804-.33-.446-.446-.446-1.166 0-1.612L24.96 6H18.57c-.628 0-1.143-.514-1.143-1.143 0-.628.515-1.143 1.143-1.143h9.143z"
        })]
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#externalLink__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0V0z"
      })
    })]
  }), /*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsx("clipPath", {
      id: "externalLink__clip0_12_2779",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    }), /*#__PURE__*/_jsx("clipPath", {
      id: "externalLink__clip1_12_2779",
      children: /*#__PURE__*/_jsx("path", {
        d: "M0 0h32v32H0z"
      })
    })]
  })]
}));
SVGExternalLink.displayName = 'SVGExternalLink';
export default SVGExternalLink;